import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import './MetaStepDisconnect.styles.scss';
import { DashboardService } from '../../../../../Dashboard.service.ts';
import { useModalsContext } from '../../../../../../../providers/ModalsProvider/Modals.context.ts';
import { IntegrationsService } from '../../../../../../../providers/IntegrationsProvider/Integrations.service.ts';
import { useWorkspaceContext } from '../../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import {
  eIntegrationStatus,
  eIntegrationType,
} from '../../../../../../../providers/IntegrationsProvider/Integrations.enums.ts';
import { useState } from 'react';
import { SignalSlashIcon } from '@heroicons/react/24/solid';
import { ArrowsRightLeftIcon } from '@heroicons/react/20/solid';
import { useToastContext } from '../../../../../../../providers/ToastProvider/Toast.hook.ts';
import { eAlertType } from '../../../../../../../providers/ToastProvider/Toast.enum.ts';

export default function MetaStepDisconnect() {
  const { t } = useTranslation('dashboard/dashboard');
  const { currentWorkspaceId } = useWorkspaceContext();
  const [loading, setLoading] = useState(false);

  const { setMetaConnectionModalIsOpen } = useModalsContext();
  const { addAlert } = useToastContext();

  async function onClick() {
    try {
      setLoading(true);
      let uuid = '';
      const data = await IntegrationsService.getIntegrations({
        uuid: currentWorkspaceId as string,
      });
      data.data.integrations.forEach((integration) => {
        if (
          integration.label === eIntegrationType.MESSENGER &&
          integration.state === eIntegrationStatus.CONNECTED
        ) {
          const selectedPage = integration?.pages?.find(
            (page) => page.isSelected,
          );
          if (selectedPage) {
            uuid = selectedPage.id;
          }
        }
      });
      await DashboardService.disconnectAndUnsubscribe(uuid);
      setMetaConnectionModalIsOpen(false);
    } catch (err) {
      addAlert({
        type: eAlertType.ERROR,
        message:
          (err as Error).message || 'Ocurrió un error al desconectar la cuenta',
      });
    }
    setLoading(false);
  }
  return (
    <div className="MetaStepDisconnect">
      <div className="flex justify-center items-center my-2">
        <SignalSlashIcon className="text-error w-8 h-8 mr-2" />
        <ArrowsRightLeftIcon className="text-primary w-7 h-7 mx-4" />
        <img
          src="/images/icons/messenger-icon.png"
          alt="messenger"
          className="w-8 h-8"
        />
      </div>
      <p className="mx-4 text-sm text-base-content">
        Al desconectar tu cuenta de Messenger, no podras recibir ni mandar
        mensajes de tus clientes en las integraciones de Meta
      </p>
      <Button
        loading={loading}
        onClick={onClick}
        color="primary"
        className="text-base-100"
      >
        {t('components.modals.MetaConnection.disconnectButton')}
      </Button>
    </div>
  );
}
